import { createCreateAccountValidator, createInviteUserValidator, createUpdateAccountValidator, } from "#validators/accounts.validator.factory";
// Use factory functions with pass-through translation for type inference
const createAccountValidatorForType = createCreateAccountValidator((key) => key);
const updateAccountValidatorForType = createUpdateAccountValidator((key) => key);
const inviteUserValidatorForType = createInviteUserValidator((key) => key);
